import { SORTORDER } from "../../utils/constants"

const tableHeadings = (classes, isAdmin, isViewOnly) => (
  [
    {
      id: 'name',
      header: 'VPP NAME',
      isLink: (isAdmin || isViewOnly) ? true : false,
      className: `${classes.tableHeading} ${classes.vppName}`
    },
    {
      id: 'programName',
      header: 'PROGRAM NAME',
      className: `${classes.tableHeading} ${classes.programName}`
    },
    {
      id: 'total_systems',
      header: 'TOTAL SYSTEMS',
      isSortable: true,
      sortOrder: SORTORDER.ASC,
      className: `${classes.tableHeading} ${classes.totSystems}`
    },
    {
      id: 'battery_capacity',
      header: 'BATTERY CAPACITY (kWh)',
      isSortable: true,
      sortOrder: SORTORDER.ASC,
      className: `${classes.tableHeading} ${classes.batteryCapacity}`
    },
    {
      id: 'total_power',
      header: 'TOTAL POWER (kW)',
      className: `${classes.tableHeading}`
    }
  ]
)

const vppForm = (programList) => {
  return [
    {
      id: "programId",
      name: "programId",
      label: "Program Name",
      type: "select",
      options: programList
    },
    {
      id: "name",
      name: "name",
      label: "Virtual Power Plant Name",
    },
    {
      id: "grpCriteria",
      name: "grpCriteria",
      label: "Grouping Criteria",
      type: "fieldArray"
    }
  ]
}

const allOptions = [
  {
    label: 'State',
    value: 'STATE'
  },
  {
    label: 'City',
    value: 'CITY'
  },
  {
    label: 'Zip/Postal Code',
    value: 'ZIP'
  },
  {
    label: 'Site IDs',
    value: 'SITE_IDS'
  }
]

const sortBy = {
  TOTALPOWER: 'total_power',
  BATTERYCAPACITY: 'battery_capacity',
  TOTALSYSTEMS: 'total_systems'
}


export {
  vppForm,
  tableHeadings,
  allOptions,
  sortBy
}